import { utils, LitElement, html, Task, paths, unsafeHTML } from '@hh/global.js'

const { fetchConfig, timeAgo } = utils

class HHFeaturedReviews extends LitElement {
  static properties = {
    okendoId: {
      type: String,
      attribute: 'okendo-id',
    },
    href: {
      type: String
    },
    buttonLabel: {
      type: String,
      attribute: 'button-label'
    }
  }

  constructor() {
    super()

    this.reviewsContainer = this.querySelector('.js-reviews-list')
  }

  connectedCallback() {
    super.connectedCallback()
  }

  disconnectedCallback() {
    super.disconnectedCallback()
  }

  _reviewsFetchingTask = new Task(this, {
    task: async ([id]) => {
      const response = await fetch(`https://api.okendo.io/v1/stores/${id}/reviews?limit=20&orderBy=date desc`, fetchConfig('json', 'GET'))
      if (!response.ok) { throw new Error(response.status); }

      const { reviews } = await response.json()

      return reviews.filter(review => !!review.productImageUrl).slice(0, 3)
    },
    args: () => [this.okendoId]
  });

  createRenderRoot() {
    return this;
  }

  render () {
    return this._reviewsFetchingTask.render({
      pending: () => html`<div class="container"><p>Loading reviews...</p></div>`,
      complete: (reviews) => html`
        <div class="featured-reviews flex fdc aic">
          <ul class="featured-reviews-list">
          ${reviews.map(review => html`
            <li class="featured-review-item">
              <div class="flex fdc gap-sm aic">
                <a href="${review.productUrl}" aria-label="View ${review.productName}" class="flex aic jcc">
                  <img src="${review.productImageUrl}" alt="${review.productName}"/>
                </a>

                <p class="mv0 body-large center">
                  ${review.body}
                </p>

                <div class="flex fdc aic gap-2xs">
                  <div class="c-tertiary flex">
                    ${(Array(review.rating).fill(0)).map(() => html`<span class="icon-sm">${unsafeHTML(paths.star)}</span>`)}
                  </div>
                  <span class="c-subdued">- ${review.reviewer.displayName}, ${timeAgo(review.dateCreated)}</span>
                </div>
              </div>
            </li>
            `)}
          </ul>

          <hh-button
            theme="tertiary"
            href="${this.href}"
          >${this.buttonLabel}</hh-button>
        </div>
      `,
      error: (e) => html``
    });
  }
}

customElements.define('hh-featured-reviews', HHFeaturedReviews)
